module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('AppHeader'), _vm._v(" "), _c('div', {
    staticClass: "app-body",
    class: {
      'no-margin': _vm.$route.query.app
    }
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fluid container-nobreadcrumb"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('AppAside')], 1), _vm._v(" "), _c('AppFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82241f9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 1040
// module chunks = 1